export function fixFirefoxDragDrop() {
    document.addEventListener('dragstart', function (event) {
        event.dataTransfer.setData('text/plain', '');
    }, true);
}
